import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "tlb_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const c = localStorage.getItem(CONSENT_KEY);
      if (!c) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const setChoice = (choice) => {
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice, at: new Date().toISOString() })); } catch (e) { /* ignore */ }
    setVisible(false);
    // Broadcast for any analytics loaders that want to hook in later
    try { window.dispatchEvent(new CustomEvent("tlb:cookie-consent", { detail: choice })); } catch (e) { /* ignore */ }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#111D33] text-[#FAF7F2]"
      style={{ borderTop: "1px solid #1B2A4A" }}
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="label-ui text-[10px] text-[#B8973A] mb-1 tracking-[0.25em]">A QUIET NOTE ON COOKIES</p>
          <p style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "1.05rem", lineHeight: 1.55 }}>
            We use one strictly-necessary cookie to keep you signed in. Analytics are off by default — you can choose to allow them below.{" "}
            <Link to="/privacy" className="text-[#E8D5A3] underline underline-offset-4 hover:text-white transition-colors" data-testid="cookie-banner-privacy-link">
              Read our privacy notice
            </Link>
            .
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => setChoice("necessary_only")}
            className="label-ui text-[11px] px-4 py-2 border border-[#8C8278] text-[#E8D5A3] hover:bg-[#1B2A4A] transition-colors"
            style={{ borderRadius: 4 }}
            data-testid="cookie-necessary-only-btn"
          >
            Necessary only
          </button>
          <button
            onClick={() => setChoice("all")}
            className="label-ui text-[11px] px-4 py-2 bg-[#B8973A] text-[#111D33] hover:bg-[#E8D5A3] transition-colors font-medium"
            style={{ borderRadius: 4 }}
            data-testid="cookie-accept-all-btn"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
